var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.5C13.1066 12.5 15.625 10.0748 15.625 7.08329C15.625 4.09175 13.1066 1.66663 10 1.66663C6.8934 1.66663 4.375 4.09175 4.375 7.08329C4.375 10.0748 6.8934 12.5 10 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1583 13.0084C13.4333 12.8667 13.75 13.075 13.75 13.3834V17.425C13.75 18.175 13.225 18.5417 12.575 18.2334L10.3417 17.175C10.15 17.0917 9.85 17.0917 9.65833 17.175L7.425 18.2334C6.775 18.5334 6.25 18.1667 6.25 17.4167L6.26667 13.3834C6.26667 13.075 6.59167 12.875 6.85833 13.0084C7.8 13.4834 8.86667 13.75 10 13.75C11.1333 13.75 12.2083 13.4834 13.1583 13.0084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandActive);
export default __webpack_public_path__ + "static/media/brand-active.66c502ecb5ab1995ed8e0560eb3fd8ef.svg";
export { ForwardRef as ReactComponent };